/***
 * @file: æ¶æ¯æ¨éæå¡
 * @author: linkun.he
 * @Date: 2019-09-25 10:10:48
 */
import { Injectable } from '@angular/core';
import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import Push from 'push.js';

import { DtpushConfig, Func, PermissionLevel } from './dtpush.interface';

@Injectable({
  providedIn: 'root',
})
export class DtPushService {
  pagesConfig: any;
  voidFunction = () => {};

  constructor(private settingsSrv: SettingsService, private i18nSrv: I18NService) {
    this.pagesConfig = this.settingsSrv.userConfig['pages'] || {};
  }

  /***
   * @description:åå»ºéç¥æ¹æ³
   * @param title æ é¢
   * @param content åå®¹
   * @param delay æ¾ç¤ºæ¶é´ï¼ä¼ 0è¡¨ç¤ºä¸æ¶å¤±,é»è®¤ä¸º0ä¸æ¶å¤±
   * @param cb ç¹å»çåè°å½æ°ãï¼ç¹å»ä¼å³é­æ­¤æç¤ºå¹¶ä¸é¡µé¢èç¦ï¼
   */
  create(title: string, content?: string, delay = 0, cb = this.voidFunction) {
    const config: DtpushConfig = {};
    if (delay > 0) {
      config.timeout = delay;
    } else {
      config.requireInteraction = true;
    }

    if (this.pagesConfig.push) {
      config.icon = this.pagesConfig.push.icon;
    }

    Push.create(title, {
      body: content,
      ...config,
      onClick() {
        cb();
        window.focus();
        this.close();
      },
    });
  }

  /***
   * @description: è·åæéç­çº§
   * @return: æéç­çº§
   */
  getPermissionLevel(): PermissionLevel {
    return Push.Permission.get();
  }

  /***
   * @description: æ¥è¯¢æ¯å¦æå±ç¤ºéç¥å¼¹çªçæéï¼éå¯¹æµè§å¨ï¼
   * @return: true, ææéï¼ falseï¼ æ æé
   */
  queryPermission(): boolean {
    return Push.Permission.has();
  }

  /***
   * @description: è¯·æ±æ¯å¦ææéå¼¹åºéç¥
   * @param succ ææéæ¶çåè°å½æ°ï¼å¿ä¼ 
   * @param fail æ æéæ¶çåè°å½æ°ï¼ éå¿ä¼ 
   * @throws æ³¨æï¼è¥ç³è¯·è®¸å¯è¿ç¨ä¸­ï¼ç¨æ·æ¬èº«æªä½åºæ¯å¦åè®¸å¼¹åºéç¥æ¶ï¼push.jsæ¥è¯¢å°çæéç æ¯`'default'`,pushjsçrequestå½æ°ä¸ä¼åè°æåæå¤±è´¥çå½æ°ï¼æéè¦å¤æ­ä¸ã
   */
  requestPermission(succ: Func, fail?: Func) {
    fail =
      fail ||
      (() => {
        console.warn(this.i18nSrv.interpret('default.request.error'));
      });
    if (this.getPermissionLevel() === 'default') {
      console.warn(this.i18nSrv.interpret('default.request.notSetting'));
      fail();
      return;
    }
    Push.Permission.request(succ, fail);
  }
}
